import { render, staticRenderFns } from "./CollapseReservaLegal.vue?vue&type=template&id=1e248eae&scoped=true"
import script from "./CollapseReservaLegal.vue?vue&type=script&lang=js"
export * from "./CollapseReservaLegal.vue?vue&type=script&lang=js"
import style0 from "./CollapseReservaLegal.vue?vue&type=style&index=0&id=1e248eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e248eae",
  null
  
)

export default component.exports